import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { selectActiveTeam, selectActiveTeamPlayerAndStaffOptions } from 'features/match/matchSlice';

import { inputSliceActions, selectSelects } from 'features/input/inputSlice';

import generateSelectPlaceholder from 'helpers/generateSelectPlaceholder';

import AdvancedSelect from 'components/AdvancedSelect';
import selectOnChange from './helpers/selectOnChange';

const EventInputYellowCard: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const team = useSelector(selectActiveTeam);
  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayerAndStaffOptions);

  if (!team) return null;

  const teamName = team.shortName ? team.shortName : team.name;

  useEffect(() => {
    dispatch(inputSliceActions.setActiveSelect(selects.yellowCard.id));
  }, []);

  const playerMessage = intl.formatMessage({ id: 'eventInput.player' });

  const onChange = (option) => {
    if (option && !option.divider) {
      selectOnChange(option, team, dispatch, intl);
    }
  };

  return (
    <div className="input-group">
      <AdvancedSelect
        title={playerMessage}
        placeholder={generateSelectPlaceholder(intl, playerMessage, teamName)}
        options={playerOptions}
        select={selects.yellowCard}
        isClearable={true}
        onChange={onChange}
      />
    </div>
  );
};

export default EventInputYellowCard;
